import { render, staticRenderFns } from "./ListPotRefundsItem.vue?vue&type=template&id=194a35c0&"
import script from "./ListPotRefundsItem.vue?vue&type=script&lang=js&"
export * from "./ListPotRefundsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports